import React from 'react';

import { KeyboardShortcutContext, RegisterShortcutOptions } from '@neptune/shared/keyboard-domain';

export const useKeyboardShortcuts = (
  shortcuts: string[],
  callback: (event: KeyboardEvent) => void | (() => void),
  options: RegisterShortcutOptions = { disableOnModalOpen: true },
) => {
  const { registerShortcut } = React.useContext(KeyboardShortcutContext);

  React.useEffect(() => {
    const registeredShortcuts = shortcuts.map((shortcut) =>
      registerShortcut(shortcut, callback, options),
    );

    return () => registeredShortcuts.forEach((unregister) => unregister());
  }, [callback, registerShortcut, shortcuts, options]);
};
